import React from 'react';
import { Paper, Typography, useTheme } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// A single row in an admin "menu" grid (Dashboard and its sub-dashboards).
// Kept as a flat, full-width list item rather than a large boxy tile so it
// reads as a menu on mobile and never overflows a narrow grid column.
const StyledPaper = styled(Paper)`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.palette.brand.border};
  box-shadow: none;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover,
  &:focus-visible {
    border-color: ${(props) => props.theme.palette.primary.main};
    background-color: ${(props) => props.theme.palette.brand.linen};
  }
`;

const IconBadge = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  width: 40px;
  height: 40px;
`;

const ContentColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

const Card = ({ icon, title, description }) => {
    const theme = useTheme();

    return (
        <StyledPaper theme={theme}>
            <IconBadge theme={theme}>
                <FontAwesomeIcon icon={icon} size="sm" color={theme.palette.background.paper} />
            </IconBadge>
            <ContentColumn>
                <Typography
                    variant="h6"
                    style={{ fontFamily: theme.typography.cardFontFamily, color: theme.palette.text.primary, fontSize: '15px', fontWeight: 600, lineHeight: 1.3 }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="body2"
                    style={{ fontFamily: theme.typography.paragraphFontFamily, color: theme.palette.text.secondary, fontSize: '13px', lineHeight: 1.3, marginTop: '2px' }}
                >
                    {description}
                </Typography>
            </ContentColumn>
            <ChevronRightIcon sx={{ flex: 'none', color: theme.palette.text.secondary, fontSize: '20px' }} />
        </StyledPaper>
    );
};

export default Card;
